module.exports = __webpack_public_path__ + "img/plant_7.d3a730f1.webp";